import { render } from "./AwardsListCarousel.vue?vue&type=template&id=59bd420c&scoped=true"
import script from "./AwardsListCarousel.vue?vue&type=script&lang=js"
export * from "./AwardsListCarousel.vue?vue&type=script&lang=js"

import "./AwardsListCarousel.vue?vue&type=style&index=0&id=59bd420c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bd420c"]])

export default __exports__